import {
	Icon,
	Button,
	Form,
	FormItem,
	Cell,
	CellGroup,
	Input,
	InputNumber,
	TextArea,
	Swiper,
	SwiperItem,
	Navbar,
	Tabs,
	TabPane,
	Grid,
	GridItem,
	Tabbar,
	TabbarItem,
	Avatar,
	Range,
	Picker,
	Popup,
	OverLay,
	Divider,
	Dialog,
	Tag,
	Switch,
	Badge,
	Collapse,
	CollapseItem,
	Drag,
	Swipe,
	Calendar,
	InfiniteLoading,
	Uploader,
	Progress,
	Sticky,
	RadioGroup,
	Radio,
} from '@nutui/nutui';

const installNutUI = (app) => {
	app.use(Button);
	app.use(Form);
	app.use(FormItem);
	app.use(Cell);
	app.use(CellGroup);
	app.use(Input);
	app.use(InputNumber);
	app.use(Icon);
	app.use(Swiper);
	app.use(SwiperItem);
	app.use(Navbar);
	app.use(Tabs);
	app.use(TabPane);
	app.use(Grid);
	app.use(GridItem);
	app.use(Tabbar);
	app.use(TabbarItem);
	app.use(Avatar);
	app.use(Range);
	app.use(Picker);
	app.use(Popup);
	app.use(OverLay);
	app.use(Divider);
	app.use(Dialog);
	app.use(Tag);
	app.use(Switch);
	app.use(Badge);
	app.use(Collapse);
	app.use(CollapseItem);
	app.use(Drag);
	app.use(Swipe);
	app.use(Calendar);
	app.use(TextArea);
	app.use(InfiniteLoading);
	app.use(Uploader);
	app.use(Progress);
	app.use(Sticky);
	app.use(RadioGroup);
	app.use(Radio);
};

export default installNutUI;
